<template>
  <!-- <v-toolbar color="#D0282E" v-show="this.$store.state.isAuthenticated"> -->
    <v-container fluid style="background-color: #D0282E;height: 76px;">
      <v-row align="center" justify="center">
        <v-col v-if="!$vuetify.breakpoint.mobile" cols="3" class="text-center pl-0" style="position: relative;">
          <div @click="$router.push({name: 'Home'}).catch(()=>{})" style="cursor: pointer;">
            <v-img
              :src="require('../../assets/imgs/logo-top.svg')"
              contain
              height="100"
              width="100"
              style="position: absolute; bottom: -60px;margin: auto;left: 0;right: 0;"
            />
          </div>
        </v-col>
        <v-col v-else cols="3" class="text-center py-0" style="position: relative;">
          <div class="d-flex align-center">
            <v-img
              :src="require('../../assets/imgs/logo-top.svg')"
              contain
              height="60"
              width="60"
            />
            <v-app-bar-nav-icon dark @click.stop="$store.commit('setDrawerState', !$store.state.drawer)"></v-app-bar-nav-icon>
          </div>
        </v-col>
        <v-col cols="9"
          :class="['Information','Atenciones','Planes','Tracking','Sales'].includes($route.name) ? 'd-flex justify-space-between':'text-right'">
          <v-btn
            v-if="['Information','Atenciones','Planes','Tracking','Sales'].includes($route.name)"
            color="#707070"
            small
            text
            rounded
            outlined
            @click="$router.push({name: 'Home'})"
            class="mx-2"
            style="background-color: white"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
            <p class="body-2 mb-0" >Volver</p>
          </v-btn>
          <div>
            <!-- <v-btn class="mx-2" rounded small dark outlined @click="$router.push({name: 'Sales'})">
              Mi panel de ventas
            </v-btn> -->
            <v-btn class="mx-2" rounded small dark outlined @click="logout ()">
              Cerrar Sesión
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
<!--     <v-toolbar-title class="px-3" style="display: flex; flex:3; height: 100%;text-align: center;position: relative;overflow: visible;">
      <v-img
        :src="require('../../assets/imgs/logo-top.svg')"
        contain
        height="100"
        width="100"
        style="position: absolute;bottom: -60px;margin: auto;left: 0;right: 0;"
      />
    </v-toolbar-title>
    <div class="px-3" style="display: flex; flex: 9; align-items: flex-end; justify-content: flex-end;">
      <v-btn rounded small dark outlined @click="logout ()">
        Cerrar Sesión
      </v-btn>
    </div> -->
  <!-- </v-toolbar> -->
</template>

<script>
  export default {
    name: 'Header',
    data: () => ({
    }),
    methods: {
      logout () {
        this.$store.commit('logoutUser', null)
        this.$router.push({name: 'Login'})
      }
    },
  }
</script>
